import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { AsyncEntity } from '../../global';
import createAsyncThunkFromFetch from '../../store/middlewares/createAsyncThunkFromFetch';
import {
  createDevice as createDeviceAPI,
  deleteDevice as deleteDeviceAPI,
  getDevice,
  getDevices,
  updateDevice as updateDeviceAPI,
} from './devicesTypes.api';
import { DeviceType } from './devicesTypes.types';

const name = 'devices';

const devicesEntityAdapter = createEntityAdapter<AsyncEntity<DeviceType>>({
  selectId: device => device.name,
});

export const devicesSelectors = devicesEntityAdapter.getSelectors();

export const fetchDeviceTypes = createAsyncThunkFromFetch(`${name}/fetchDevices`, getDevices);
export const fetchDevice = createAsyncThunkFromFetch(`${name}/fetchDevice`, getDevice);
export const deleteDevice = createAsyncThunkFromFetch(`${name}/deleteDevice`, deleteDeviceAPI);
export const createDevice = createAsyncThunkFromFetch(`${name}/createDevice`, createDeviceAPI);
export const updateDevice = createAsyncThunkFromFetch(`${name}/editDevice`, updateDeviceAPI);

const devicesSlice = createSlice({
  name,
  initialState: devicesEntityAdapter.getInitialState({
    isPending: false,
    hasError: false,
  }),
  reducers: {},
  extraReducers: builder => {
    builder.addCase(fetchDeviceTypes.pending, state => {
      state.isPending = true;
      state.hasError = false;
    });
    builder.addCase(fetchDeviceTypes.fulfilled, (state, { payload }) => {
      devicesEntityAdapter.upsertMany(state, payload);
      state.isPending = false;
      state.hasError = false;
    });
    builder.addCase(fetchDeviceTypes.rejected, state => {
      state.isPending = false;
      state.hasError = true;
    });
    builder.addCase(fetchDevice.fulfilled, (state, { payload }) => {
      devicesEntityAdapter.upsertOne(state, payload);
    });
    builder.addCase(deleteDevice.pending, (state, { meta }) => {
      devicesEntityAdapter.updateOne(state, {
        id: meta.arg.deviceTypeName,
        changes: { isPending: true },
      });
    });
    builder.addCase(deleteDevice.fulfilled, (state, { meta }) => {
      devicesEntityAdapter.removeOne(state, meta.arg.deviceTypeName);
    });
    builder.addCase(deleteDevice.rejected, (state, { meta }) => {
      devicesEntityAdapter.updateOne(state, {
        id: meta.arg.deviceTypeName,
        changes: { isPending: false, hasError: true },
      });
    });
    builder.addCase(createDevice.fulfilled, (state, { payload }) => {
      devicesEntityAdapter.upsertOne(state, payload);
    });
  },
});

const { reducer } = devicesSlice;

export default reducer;
